import { AddVoyageScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Yeni sefer ya da düzenleme (`?vessel=<id>&voyage=<id>`); sefer ofiste planlanır (ADR 0022 §1). */
export function AddVoyagePage() {
  const { t } = useTranslation();
  const [params] = useSearchParams();
  return (
    <Shell title={t('voyage.planner.title')}>
      <AddVoyageScreen
        source={officeVoyageSource}
        voyageId={params.get('voyage')}
        vesselHint={params.get('vessel')}
        // Ofisin sefer talebi kalkıştan (ADR 0157 §2): kalkış ve kuyruğu talebin raporları
        departureId={params.get('departure')}
      />
    </Shell>
  );
}
